import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { DotSize } from "../Carousel.types";
import { shadows } from "../../../../theme/foundations/generated";
const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(["container", "carousel", "title"]);
const baseStyle = definePartsStyle(({ variant, dots, arrows }) => ({
    container: {
        height: "100%",
        marginBottom: ".625rem",
        padding: "1rem",
    },
    carousel: {
        ".custom-slider": {
            position: "relative",
            display: "flex !important",
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
        },
        "& ul.slick-dots": {
            position: "relative",
            display: "flex !important",
            flexDirection: "row",
            marginTop: "1rem",
            bottom: 0,
            columnGap: "1rem",
            justifyContent: "center",
            alignItems: "center",
            "&>li": {
                position: "relative",
                display: "block",
                height: `${DotSize[variant]}rem !important`,
                width: `${DotSize[variant]}rem !important`,
                margin: 0,
                padding: 0,
                cursor: "auto",
                "& button": {
                    backgroundColor: "semantic.icon.secondary",
                    height: "100%",
                    width: "100%",
                    padding: 0,
                    borderRadius: "50%",
                    "&::before": {
                        content: '""',
                        position: "relative",
                    },
                    _hover: {
                        background: "semantic.cta.secondaryHover",
                    },
                    _focusVisible: {
                        background: "semantic.cta.secondaryHover",
                        outline: `3px solid`,
                        outlineColor: "semantic.outline.focus",
                        outlineOffset: "2px",
                    },
                    _active: {
                        background: "semantic.cta.secondary",
                    },
                },
            },
            "&>li.slick-active": {
                "& button": {
                    background: "semantic.cta.secondary",
                },
            },
        },
        ".slick-arrow": {
            position: "absolute",
            height: 12,
            top: dots ? "calc(50% - 1rem)" : "50%",
            background: arrows ? "semantic.surface.1" : "inherit",
            boxShadow: arrows ? shadows.medium : "none",
            _loading: {
                background: "semantic.cta.secondaryHover",
            },
            _hover: {
                background: "semantic.cta.secondaryHover",
                color: "semantic.text.primary",
                _disabled: {
                    color: "semantic.text.disabled",
                },
                _loading: {
                    background: "semantic.cta.secondaryHover",
                },
            },
            _focusVisible: {
                background: "semantic.cta.secondaryHover",
            },
            _active: {
                background: "semantic.cta.secondaryPressed",
                color: "semantic.text.inverse",
            },
            _disabled: {
                color: "semantic.text.disabled",
            },
            color: "semantic.interactive.primary",
            zIndex: 1,
            lineHeight: "normal",
            "&::before": {
                content: "none",
            },
            "&.slick-prev": {
                left: "6",
            },
            "&.slick-next": {
                right: "6",
            },
            "&.slick-prev:hover, &.slick-prev:focus, &.slick-next:hover, &.slick-next:focus": {
                background: arrows ? "semantic.surface.1" : "inherit",
                color: "semantic.interactive.primary",
                boxShadow: arrows ? shadows.medium : "none",
            },
        },
    },
    title: {
        marginBottom: "1rem",
    },
}));
const CarouselTheme = defineMultiStyleConfig({
    baseStyle,
});
export default CarouselTheme;
//# sourceMappingURL=Carousel.default.js.map